import { render } from "./FontsComponent.vue?vue&type=template&id=0f21d17a"
import script from "./FontsComponent.vue?vue&type=script&lang=js"
export * from "./FontsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__